import React, { useState, Fragment } from 'react'
import { TableCell } from '@material-ui/core'
import { parse, format } from 'date-fns'

import { dropTimeZoneFromDate } from 'shared/libraries/utils/date'
import { dateTimeFormat } from './constants'
import {
  StyledTableRow,
  StyledCollapsibleRow,
  StyledTableCell,
  StyledFlyerPacksCell,
  StyledRedirectButton,
} from './style'

const getRowClass = index => {
  return index % 2 === 0 ? 'zebra' : ''
}

const TableRow = ({ data, index, onRedirectPickupAll }) => {
  const [campaignsVisible, setCampaignsVisible] = useState(false)
  const {
    campaigns,
    name,
    phoneNumber,
    email,
    nextMissionDate,
    nextPickupDate,
    flyerPacksMissing,
    totalMissions,
    totalFlyerPacks,
  } = data

  const ambassadorNextMissionDate = nextMissionDate
    ? format(parse(dropTimeZoneFromDate(nextMissionDate)), dateTimeFormat)
    : ''
  const ambassadorNextPickupDate = nextPickupDate
    ? format(parse(dropTimeZoneFromDate(nextPickupDate)), dateTimeFormat)
    : ''

  return (
    <Fragment key={name}>
      <StyledTableRow
        onClick={() => setCampaignsVisible(!campaignsVisible)}
        className={getRowClass(index)}
      >
        <StyledTableCell>{name}</StyledTableCell>
        <StyledTableCell>{phoneNumber}</StyledTableCell>
        <StyledTableCell>
          <a href={`mailto:${email}`}>{email}</a>
        </StyledTableCell>
        <StyledTableCell>
          {ambassadorNextPickupDate || 'No time specified'}
        </StyledTableCell>
        <StyledTableCell>
          {ambassadorNextMissionDate || 'No time specified'}
        </StyledTableCell>
        <StyledTableCell>{totalMissions}</StyledTableCell>
        <StyledFlyerPacksCell
          highlight={!campaignsVisible && flyerPacksMissing}
        >
          {totalFlyerPacks}
        </StyledFlyerPacksCell>
      </StyledTableRow>
      {campaigns.map((campaign, index) => {
        const campaignName = campaign.missions[0]['CAMPAIGN NAME']
        const missionsTotal = campaign.missions.length
        const flyerPacksTotal = campaign.flyerPacks.length
        const campaignNextMissionDate = campaign.nextMissionDate
          ? format(
              parse(dropTimeZoneFromDate(campaign.nextMissionDate)),
              dateTimeFormat,
            )
          : 'No time specified'
        const campaignNextPickupDate = campaign.nextPickupDate
          ? format(
              parse(dropTimeZoneFromDate(campaign.nextPickupDate)),
              dateTimeFormat,
            )
          : 'No time specified'

        return (
          <StyledCollapsibleRow
            visible={campaignsVisible}
            className={getRowClass(index)}
            key={`collapsible-row-${index}`}
          >
            <TableCell colSpan={3}>
              <StyledRedirectButton
                onClick={() => onRedirectPickupAll(campaignName, name)}
              >
                {campaignName}
              </StyledRedirectButton>
            </TableCell>
            <TableCell>{campaignNextPickupDate}</TableCell>
            <TableCell>{campaignNextMissionDate}</TableCell>
            <TableCell>{missionsTotal}</TableCell>
            <StyledFlyerPacksCell highlight={missionsTotal > flyerPacksTotal}>
              {flyerPacksTotal}
            </StyledFlyerPacksCell>
          </StyledCollapsibleRow>
        )
      })}
    </Fragment>
  )
}

export default TableRow
